import en from './en';
import sv from './sv';

const resources = {
  en,
  sv,
};

export default resources;
